import { CardContents } from "./internal/CardContents.js";
import { Card, CardSection } from "@mantine/core";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/BaseCard.tsx
const BaseCard = ({ children, header, footer, Icon, iconColor, iconBackground, onClick, role, fullWidthFooter, pinFooter, fullHeight, style = {}, "data-testid": testId, ...restProps }) => {
	const cursor = onClick ? "pointer" : "default";
	const CardFooter = fullWidthFooter && footer ? /* @__PURE__ */ jsx(CardSection, {
		mt: "xxxs",
		children: footer
	}) : footer;
	return /* @__PURE__ */ jsx(Card, {
		...restProps,
		flex: 1,
		style: {
			...style,
			container: "card / inline-size",
			cursor,
			height: fullHeight ? "100%" : void 0
		},
		"data-testid": testId,
		onClick,
		role,
		children: /* @__PURE__ */ jsx(CardContents, {
			header,
			footer: CardFooter,
			pinFooter,
			Icon,
			iconColor,
			iconBackground,
			children
		})
	});
};

//#endregion
export { BaseCard };